import { api } from '~/application/api';
import type { ApplicationResult, CollectionResult } from '~/application/types';
import type { ShippingProvider } from './types';

const shippingApi = api.enhanceEndpoints({
    addTagTypes: ['ShippingProvider']
}).injectEndpoints({
    endpoints: build => ({
        createShippingProvider: build.mutation<ApplicationResult, Partial<ShippingProvider>>({
            query: (request) => ({
                url: '/shipping-providers',
                method: 'POST',
                body: request,
            }),
            invalidatesTags: ['ShippingProvider'],
        }),
        deleteShippingProvider: build.mutation<ApplicationResult, string | number>({
            query: (id) => ({
                url: `/shipping-providers/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_, __, id) =>
                [{ type: 'ShippingProvider', id }],
        }),
        listShippingProviders: build.query<CollectionResult<ShippingProvider>, string>({
            query: (queryString) => `/shipping-providers?${queryString}`,
            providesTags: result => result
                ? result.collection.map(provider => ({ type: 'ShippingProvider', id: provider.id }))
                : ['ShippingProvider'],
        }),
        shippingProviderDetails: build.query<ShippingProvider, string | number>({
            query: (id) => `/shipping-providers/${id}`,
            providesTags: (_, __, id) =>
                [{ type: 'ShippingProvider', id }],
        }),
        updateShippingProvider: build.mutation<ApplicationResult, ShippingProvider>({
            query: (request) => ({
                url: `/shipping-providers/${request.id}`,
                method: 'POST',
                body: request,
            }),
            invalidatesTags: (_, __, arg) =>
                [{ type: 'ShippingProvider', id: arg.id }],
        }),
    }),
});

export const {
    useCreateShippingProviderMutation,
    useDeleteShippingProviderMutation,
    useListShippingProvidersQuery,
    useShippingProviderDetailsQuery,
    useUpdateShippingProviderMutation,
} = shippingApi;
